import { NotifyHelper } from "../../../helpers/toast";
import { eXetHocVuActionsObj } from "../../action-types/xet-hoc-vu/IXetHocVuActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xetHocVuActions = {
    ...generateActions(eXetHocVuActionsObj, "XET_HOC_VU"),
    ...generateActionForKey(eXetHocVuActionsObj, "XET_HOC_VU", "XET_SUCCESS", (m) => {
        NotifyHelper.Success(m);
    }),
     ...generateActionForKey(eXetHocVuActionsObj, "XET_HOC_VU", "XET_ERROR", (m) => {
        NotifyHelper.Error(m);
    })
}